import { borderColor } from './color';
export default {
  axisPointer: {
    lineStyle: {
      color: borderColor.normal,
      width: 1
    },
    crossStyle: {
      color: borderColor.normal,
      width: 1
    }
  },
  textStyle: {
    fontSize: 12
  },
  padding: [12, 12]
};